import { useCallback } from 'react';

import type { Id } from '@e-socna/data-layer';

import { usePrinterContext } from '../../../contexts/PrinterContext/hooks/usePrinterContext.hook';
import type { OnPrintHandler } from '../../../components/DocumentEditor/types/props.type';

import { useQueryInvalidation } from './useQueryInvalidation.hook';

interface Params {
  readonly documentTemplateId: Id;
  readonly snackbarActionTarget: string;
}

export const usePrintHandler = ({
  documentTemplateId,
  snackbarActionTarget,
}: Readonly<Params>) => {
  const { queryKeyToInvalidate } = useQueryInvalidation(documentTemplateId);

  const { print } = usePrinterContext();

  const onPrint = useCallback<OnPrintHandler>(
    (params) => {
      print({
        ...params,
        printableId: documentTemplateId,
        snackbarActionTarget,
        command: 'printDocumentTemplate',
        queryKeysToInvalidate: [queryKeyToInvalidate],
      });
    },
    [documentTemplateId, print, queryKeyToInvalidate, snackbarActionTarget],
  );

  return {
    onPrint,
  };
};
